import styled from "styled-components";

export const Container = styled.footer`
  width: 100%;
  height: 366px;
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  padding: 56px 50px 49px;
  background: ${({ theme }) => theme.colors.primary};

  @media screen and (max-width: 768px) {
    flex-direction: column;
    height: auto;
    padding: 40px 1.5rem 20px;
    gap: 1.5rem;
    
  }

  > div {
    width: 35%;
    display: flex;
    flex-direction: column;
    
    @media screen and (max-width: 768px){
      width: 100%;
    }

    ul {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 20px;
      margin: 16px auto 40px;

      li {
        list-style: none;

        a {
          text-decoration: none;
          color: #ffffff;
          font-size: 26px;
          transition: all 0.3s;

          :hover {
            opacity: 0.6;
          }
        }
      }
    }

    > a {
      color: #ffffff;
      line-height: 2;
      text-decoration: underline;

      display: flex;
      align-items: center;
      justify-content: flex-start;

      span {
        margin-left: 8px;
      }
    }

    a.endereco {
      margin-bottom: 40px;
      text-decoration: none;
    }

    a.whatsapp {
      text-decoration: none;
    }
  }
`;
